export function createId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `id-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

export function titleFromPrompt(text) {
  const line = text.split('\n')[0].trim()
  if (line.length <= 56) return line || 'New chat'
  return `${line.slice(0, 56)}…`
}
